import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { AVATAR_HEIGHT_16 } from '../../../Avatar'
import {
  SelectDropdownEntityListItemContent,
  SelectDropdownListItem,
} from '../../../Select'
import { isChatroomTemplatePublic } from '../ChatroomInputTemplateSelect.utils'

import PrivateIcon from '../../../../icons/lock.svg'
import UsersIcon from '../../../../icons/users-1.svg'

function ChatroomInputTemplateSelectDropdownListItem({
  ref,
  value,
  ...restProps
}) {
  const { t } = useTranslation()

  const isPublic = isChatroomTemplatePublic(value)

  const Icon = isPublic ? UsersIcon : PrivateIcon

  const tooltip = t(
    isPublic
      ? 'Chatroom.TemplatePublicTooltipKey'
      : 'Chatroom.TemplatePrivateTooltipKey'
  )

  return (
    <SelectDropdownListItem
      {...restProps}
      Content={SelectDropdownEntityListItemContent}
      contentProps={{
        ...restProps?.contentProps,
        avatarProps: {
          ...restProps?.contentProps?.avatarProps,
          iconSize: AVATAR_HEIGHT_16,
          iconTooltip: tooltip,
          size: AVATAR_HEIGHT_16,
        },
      }}
      ref={ref}
      value={{ ...value, Icon }}
    />
  )
}

export default memo(ChatroomInputTemplateSelectDropdownListItem)
